import { ImageMagnify, ImageContainer, Image, Portal, PortalContainer, MagnifyContainer } from './styles'

ImageMagnify.ImageContainer = ImageContainer
ImageMagnify.Image = Image
ImageMagnify.Portal = Portal
ImageMagnify.PortalContainer = PortalContainer
ImageMagnify.MagnifyContainer = MagnifyContainer

export default ImageMagnify
